'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REFRESH_WIDGET_DATA = exports.REFRESH_WIDGET_DATA = 'REFRESH_WIDGET_DATA';
var UPDATE_SESSION_ID = exports.UPDATE_SESSION_ID = 'UPDATE_SESSION_ID';